import * as React from 'react';

import type { ParametersClient } from '@/api/parameters-client';
import { HttpParametersClient } from '@/api/parameters-client.http';

// Impl HTTP réelle par défaut (Phase 2, D2a-LECT) : le stub reste injectable via le
// provider pour les tests. Instance partagée (sans état interne).
const defaultParametersClient: ParametersClient = new HttpParametersClient();

// =============================================================================
// parameters-client-context.tsx — Injection du ParametersClient (DI seam).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle
// plus tard) sans toucher l'UI. Par défaut : le StubParametersClient (Option B).

const ParametersClientContext =
  React.createContext<ParametersClient>(defaultParametersClient);

export interface ParametersClientProviderProps {
  client?: ParametersClient | undefined;
  children: React.ReactNode;
}

export function ParametersClientProvider({
  client = defaultParametersClient,
  children,
}: ParametersClientProviderProps): React.JSX.Element {
  return (
    <ParametersClientContext.Provider value={client}>
      {children}
    </ParametersClientContext.Provider>
  );
}

export function useParametersClient(): ParametersClient {
  return React.useContext(ParametersClientContext);
}
